import { render } from "./AdminGameDayView.vue?vue&type=template&id=3def30e6"
import script from "./AdminGameDayView.vue?vue&type=script&lang=js"
export * from "./AdminGameDayView.vue?vue&type=script&lang=js"

import "./AdminGameDayView.vue?vue&type=style&index=0&id=3def30e6&lang=css"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__